module.exports = __webpack_public_path__ + "static/media/exponentlogo.0a287352.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/exponentlogo.png
 ** module id = 163
 ** module chunks = 0
 **/